const REPAIR_COST = 4;
const REPAIR_COST_STEP = 2;
export const REPAIR_HEAL = 3;
export const FIRST_STRIKE_SHARDS = 1;

export const getSectorRepairCount = (game) =>
  game.repairPurchases?.floor === game.floor &&
  Number.isSafeInteger(game.repairPurchases.count) &&
  game.repairPurchases.count >= 0
    ? game.repairPurchases.count
    : 0;

export const getRepairCost = (game) =>
  REPAIR_COST + getSectorRepairCount(game) * REPAIR_COST_STEP;

export const REPAIR_DESCRIPTION =
  'Heal 3 health. If your health is full, the extra healing increases how much health you can hold. Each extra heal in this area costs 2 more shards. The price resets in the next area.';
